import { NgModule } from "@angular/core";
import { DayjsFormatPipe } from "./dayjs-format.pipe";
import { CommonModule } from "@angular/common";

@NgModule({
    imports: [
        CommonModule,
        DayjsFormatPipe
    ],
    exports: [
        DayjsFormatPipe // <-- export it so it's available elsewhere
    ]
})
  export class DayjsFormatModule {}